import { IThongTinToChucThiRequest } from "./../../../model/request/category/IThongTinToChucThiRequest";
import { IThongTinToChucThi } from "../../../model/respone/category/IThongTinToChucThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IDotThiVm } from "../../../model/respone/category/IDotThi";

export const eToChucThiActionsObj = {
  LOAD_START: {} as IThongTinToChucThiRequest,
  LOAD_SUCCESS: {} as IThongTinToChucThi[],
  LOAD_ERRR: "",

  LOAD_DOT_THI_START: {} as any,
  LOAD_DOT_THI_SUCCESS: {} as IDotThiVm[],
  LOAD_DOT_THI_ERRR: "",

  CHANGE_REQUEST: {} as any,
};
export const eToChucThiActionIds = generateActionTypeIds(
  eToChucThiActionsObj,
  "TO_CHUC_THI"
);
export type IToChucThiActionTypes = IGenericActionType<
  typeof eToChucThiActionsObj,
  "TO_CHUC_THI"
>;
